
import { Component, Vue } from 'vue-property-decorator';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  inject: [
    'profileRepository',
  ],
})
export default class ToggleThemeBtn extends Vue {
  private text: string = 'Dark Theme';
  private profileRepository: ProfileRepositoryInterface;

  private async saveThemeChoice(isDark: boolean): Promise<void> {
    this.$store.commit('UPDATE_THEME', isDark);
    await this.profileRepository.updateProfileConfig(this.$store.getters.profileId, { enabledDarkTheme: isDark });
  }

}
